import { Button } from '../../components/ui';
import { drillCount } from './drill';
import type { Drill } from './drill';

/**
 * What set is on the table, and how to get out of it.
 *
 * ── Why a banner and not a filter chip ─────────────────────────────────────
 *
 * leadFilters.test.ts asserts that every filter names itself in the summary
 * row, and `onlyLeadIds` is exempt there with this component named as the
 * reason. That exemption is only honest if this exists and says more than a
 * chip could.
 *
 * A chip could say "461 leads" and nothing else. It could not say WHICH 461,
 * where they came from, or why the number is 461 and not 462. Somebody who
 * lands on a narrowed table without knowing why is looking at a bug.
 *
 * ── Why the definition is here ─────────────────────────────────────────────
 *
 * "Why is this two and not three" is asked at exactly the moment somebody
 * drills in. FUNNEL_EXPLAINERS already holds the sentence, written next to the
 * arithmetic so the two cannot drift, and the drill carries it through.
 */
export function DrillBanner({ drill, onClear }: { drill: Drill; onClear: () => void }) {
  const count = drillCount(drill);
  return (
    <div className="drill-banner" role="status">
      <div className="drill-banner-main">
        <p className="drill-banner-label">
          {drill.label}
          <span className="drill-banner-count">
            {' · '}
            {count === 0 ? 'nothing matched' : `${String(count)} ${count === 1 ? 'lead' : 'leads'}`}
          </span>
        </p>
        {drill.why === '' ? null : <p className="drill-banner-why">{drill.why}</p>}
      </div>
      <Button variant="secondary" size="sm" onClick={onClear}>
        Clear
      </Button>
    </div>
  );
}
